module.exports = "/_next/static/images/yogoro_top-f047139610dbef61fd16302ed53c78f0.jpg";